<template>
  <div class="menuContentBox">
    <div style="width: 100%;background-color: #fff;">
  <div class="breadBox">
    <a-breadcrumb>
      <span>
        <img src="@/assets/img/position.png"/>
        当前位置：
      </span>
      <a-breadcrumb-item style="cursor: pointer;" @click="$router.push({ path: '/knowledge/index'})">首页</a-breadcrumb-item>
      <a-breadcrumb-item>创业项目</a-breadcrumb-item>
    </a-breadcrumb>
  </div>
  <router-view/>
  </div>
  </div>
</template>
<script>
export default {
  name: 'investor',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {

    }
  },
	methods: {
		goMore(url,key) {
      this.$router.push({
				path: url,
				query: { type: key }
			})
      this.$parent.$parent.clearHeadFun()
		},
		backhome() {
			this.$router.push('/')
		}
	}
}
</script>
<style scoped lang="less">
@import "../../css/components.less";
</style>